const dateTimeInputPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;

export function formatUtcIsoForDateTimeInput(value: string | null): string {
  if (value === null) {
    return "";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value.slice(0, 16);
  }

  return [
    date.getUTCFullYear().toString().padStart(4, "0"),
    (date.getUTCMonth() + 1).toString().padStart(2, "0"),
    date.getUTCDate().toString().padStart(2, "0"),
  ]
    .join("-")
    .concat(
      `T${date.getUTCHours().toString().padStart(2, "0")}:${date
        .getUTCMinutes()
        .toString()
        .padStart(2, "0")}`,
    );
}

export function parseDateTimeInputToUtcIso(value: string): string {
  const trimmed = value.trim();
  const match = dateTimeInputPattern.exec(trimmed);

  if (match === null) {
    return new Date(trimmed).toISOString();
  }

  const [, year, month, day, hour, minute] = match;
  return new Date(
    Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), 0, 0),
  ).toISOString();
}
